import { render, staticRenderFns } from "./ContactPersonFormWrapper.vue?vue&type=template&id=625c80d8&scoped=true&"
import script from "./ContactPersonFormWrapper.vue?vue&type=script&lang=js&"
export * from "./ContactPersonFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c80d8",
  null
  
)

export default component.exports